import React, { useState, Fragment } from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../../Shared/components/controls/Button/index.js';
import LoginLinks from '../LoginLinks';
import clsx from 'clsx';

const HeaderButtons = ({ links, loginOnly, isEliteTheme }) => {
  const [isLoginActive, setLoginActive] = useState(false);
  const toggleLoginMenu = () => {
    setLoginActive(!isLoginActive);
    if (isLoginActive) {
      document.body.classList.remove('login-open');
    } else {
      document.body.classList.add('login-open');
    }
  };
  return (
    <div className="app-header-navigation-links">
      {links
        ?.filter((item) => {
          const main = !!item.fields.link?.value?.href || item.fields.items?.length > 0;
          if (loginOnly) return item.displayName === 'Login' && main;
          return main;
        })
        .map((item, index) => {
          const needIcon = !!item?.fields?.linkIcon?.value?.src;
          const link = item?.fields?.link;
          const title = item?.fields?.title?.value;
          const href = item?.fields?.link.value?.href;

          return (
            <Fragment key={index}>
              {href !== '' && href?.length > 8 && (
                <Button
                  link={link}
                  className={clsx('ahnl-button')}
                  variant="outlined"
                  color="secondary"
                >
                  {needIcon && <Image field={item.fields?.linkIcon} className="ahnl-icon" />}
                  <span className="ahnl-text">{title}</span>
                </Button>
              )}
              {(href === '' || href?.length <= 8) && (
                <Fragment>
                  <Button
                    className={clsx('ahnl-button', isEliteTheme && 'ahnl-button-elite-login')}
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      toggleLoginMenu();
                    }}
                  >
                    {needIcon && <Image field={item.fields?.linkIcon} className="ahnl-icon" />}
                    <span className="ahnl-text">{title}</span>
                  </Button>

                  {item?.fields?.items?.length > 0 && (
                    <LoginLinks
                      item={item}
                      isLoginActive={isLoginActive}
                      toggleLoginMenu={toggleLoginMenu}
                    ></LoginLinks>
                  )}
                </Fragment>
              )}
            </Fragment>
          );
        })}
    </div>
  );
};

export default HeaderButtons;
